export default {"src":"/_next/static/media/fork-and-knife.a3e276fe.svg","height":32,"width":28,"blurWidth":0,"blurHeight":0};